export const CATEGORIES = ['Hair', 'Nails', 'Massage', 'Skincare', 'Spa', 'Makeup', 'Other'];
